

import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { listadoProveedoresSelect, listadoTodosProveedores, proveedorXID } from "../../../services";




export const useProveedorXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['proveedorXid', id], 
        queryFn: () => proveedorXID(id),
        enabled: !!id,
    });

    return { data, isLoading }
}





export const useProveedoresSelect = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['proveedoresSelct'], 
        queryFn: () => listadoProveedoresSelect(),
    });

    return { data, isLoading }
}



export const useTodosProveedores = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['proveedor-todos', { page, termino }], 
        queryFn: () => listadoTodosProveedores({ page, termino }),
    });

    const chagePage = useCallback((num) => {
        setPage(num - 1);
    }, [])


    const chageTermino = useCallback((valor) => {
        setPage(0);
        setTermino(valor)
    }, [])

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}

